var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8433 9.3175C20.075 7.7175 17.0624 2.5 10.4999 2.5C3.93739 2.5 0.924762 7.7175 0.156512 9.3175C0.0533833 9.53192 0 9.76499 0 10.0008C0 10.2367 0.0533833 10.4697 0.156512 10.6842C0.924762 12.2825 3.93739 17.5 10.4999 17.5C17.0624 17.5 20.075 12.2825 20.8433 10.6825C20.9462 10.4683 20.9995 10.2355 20.9995 10C20.9995 9.76446 20.9462 9.53168 20.8433 9.3175ZM10.4999 15C9.46154 15 8.4465 14.7068 7.58314 14.1573C6.71979 13.6079 6.04688 12.827 5.64952 11.9134C5.25216 10.9998 5.14819 9.99445 5.35077 9.02455C5.55334 8.05464 6.05335 7.16373 6.78758 6.46447C7.5218 5.7652 8.45726 5.289 9.47566 5.09607C10.4941 4.90315 11.5497 5.00216 12.509 5.3806C13.4683 5.75904 14.2882 6.3999 14.8651 7.22215C15.442 8.04439 15.7499 9.01109 15.7499 10C15.7485 11.3257 15.1949 12.5967 14.2107 13.5341C13.2264 14.4715 11.8918 14.9987 10.4999 15Z",
    fill: "url(#paint0_linear_2114_557)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.3332C12.433 13.3332 14 11.8408 14 9.99984C14 8.15889 12.433 6.6665 10.5 6.6665C8.567 6.6665 7 8.15889 7 9.99984C7 11.8408 8.567 13.3332 10.5 13.3332Z",
    fill: "url(#paint1_linear_2114_557)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2114_557",
    x1: 0,
    y1: 10.9375,
    x2: 20.9995,
    y2: 10.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2114_557",
    x1: 7,
    y1: 10.4165,
    x2: 14,
    y2: 10.4165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.29d3ed88878f7e8d44ee5cf162567150.svg";
export { ForwardRef as ReactComponent };